// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import "share-api-polyfill";

const SHARE_BUTTON = document.getElementById("share-button");

if (SHARE_BUTTON) {
    SHARE_BUTTON.addEventListener("click", () => {
        navigator.share({
            title: SHARE_BUTTON.dataset.title,
            text: SHARE_BUTTON.dataset.text,
            url: location.href
        });
    }, { passive: true });
}
